module.exports = __webpack_public_path__ + "static/media/rgb-selector.355f6583.png";